import { render, staticRenderFns } from "./PerformanceTargetsTabAnalysis.vue?vue&type=template&id=6bb32364&scoped=true"
import script from "./PerformanceTargetsTabAnalysis.vue?vue&type=script&lang=js"
export * from "./PerformanceTargetsTabAnalysis.vue?vue&type=script&lang=js"
import style0 from "./PerformanceTargetsTabAnalysis.vue?vue&type=style&index=0&id=6bb32364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb32364",
  null
  
)

export default component.exports